<script setup lang="ts">

</script>
<template>
  <div>
    <div class="flex min-h-screen flex-1">
      <NuxtLoadingIndicator />
      <div class="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
        <div class="mx-auto w-full max-w-sm lg:w-96">

          <slot />
        </div>
      </div>
      <div class="relative hidden w-0 flex-1 lg:block">
        <img class="absolute inset-0 h-full w-full object-cover" fetchpriority="high" src="https://images.unsplash.com/photo-1453928582365-b6ad33cbcf64?q=80&w=873&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="login" />
      </div>
    </div>
  </div>
</template>
